/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowUpTail = createReactComponent("arrow-up-tail", "IconArrowUpTail", [
  ["path", { d: "M12 18l0 -15", key: "svg-0" }],
  ["path", { d: "M15 6l-3 -3l-3 3", key: "svg-1" }],
  ["path", { d: "M15 21l-3 -3l-3 3", key: "svg-2" }]
]);

export { IconArrowUpTail as default };
//# sourceMappingURL=IconArrowUpTail.js.map
